type BrandMarkProps = {
  variant?: 'icon' | 'lockup';
  size?: number;
  className?: string;
  decorative?: boolean;
};

const ICON_SRC = '/ukrop-nm-icon.png?v=2';
const LOCKUP_SRC = '/ukrop-nm-logo.png?v=2';

export function BrandMark({
  variant = 'icon',
  size = 32,
  className = '',
  decorative = false,
}: BrandMarkProps) {
  if (variant === 'lockup') {
    return (
      <img
        src={LOCKUP_SRC}
        alt={decorative ? '' : 'UKROP Network Manager'}
        className={`brand-lockup ${className}`.trim()}
        aria-hidden={decorative || undefined}
      />
    );
  }
  return (
    <img
      src={ICON_SRC}
      alt={decorative ? '' : 'UKROP Network Manager'}
      width={size}
      height={size}
      className={`brand-icon ${className}`.trim()}
      aria-hidden={decorative || undefined}
    />
  );
}
